/**
 * True for Enterprise Broker accounts — the accounts eligible for the Social
 * "Act As" icon/button (when also permitted by the business rules, i.e.
 * `showActAsButton`).
 *
 * Covers every Enterprise Broker variant:
 *   - Enterprise Parent Broker      (`isEnterprise`)
 *   - Enterprise Child Broker        (`isEnterpriseChild`)
 * as long as the account type is Broker.
 *
 * Enterprise children are flagged with `isEnterpriseChild`, NOT `isEnterprise`
 * (which flags only the parent), so BOTH must be accepted here. Gating on the
 * parent-only `isEnterpriseParent` (isEnterprise && !isEnterpriseChild) is what
 * wrongly hid the icon for eligible Enterprise Child Brokers logging in
 * directly to Social.
 *
 * Agent accounts are always excluded, regardless of plan: account `type` is
 * only ever 'broker' or 'agent' (Account::TYPE_BROKER / Account::TYPE_AGENT),
 * so requiring 'broker' rules agents out.
 *
 */
interface EnterpriseBrokerUser {
	isEnterprise?: boolean;
	isEnterpriseChild?: boolean;
	type?: string;
}

const isEnterpriseBroker = (user?: EnterpriseBrokerUser | Record<string, any>): boolean => {
	const accountType = String(user?.type ?? '').toLowerCase();
	const isEnterpriseAccount =
		Boolean(user?.isEnterprise) || Boolean(user?.isEnterpriseChild);

	return isEnterpriseAccount && accountType === 'broker';
};

export default isEnterpriseBroker;
